import {createReducer} from '@reduxjs/toolkit'
import {sendRsvp, sendRsvpOld} from '../actions/rsvp'
import {GuestState} from '../types/state'

const initialState: GuestState = null

export const guest = createReducer(initialState, builder => {
  builder
    .addCase(sendRsvp.fulfilled, (_, action) => action.payload.rsvp)
    .addCase(sendRsvpOld.fulfilled, (_, action) => action.payload.rsvp)
})
